/**
 * Product Compare (Vergleichsliste)
 * Cross-product variant comparison for yarn colorways.
 * Supports: DE, EN, FR, IT, ES
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'product-compare-list';
  var MAX_ITEMS = 4;

  /* -----------------------------------------------------------------------
     i18n
     ----------------------------------------------------------------------- */

  var TRANSLATIONS = {
    de: {
      addToCompare: 'Zur Vergleichsliste hinzuf\u00fcgen',
      added: 'Hinzugef\u00fcgt',
      removed: 'Entfernt',
      yarn: 'Garn',
      yarns: 'Garne',
      maxItems: 'Maximal {n} Garne',
      show: 'Anzeigen',
      compareList: 'Vergleichsliste',
      removeAll: 'Alle entfernen',
      loading: 'Daten werden geladen\u2026',
      minTwo: 'Mindestens 2 Garne zum Vergleichen hinzuf\u00fcgen.',
      loadError: 'Daten konnten nicht geladen werden.',
      remove: 'Entfernen',
      brand: 'Marke',
      price: 'Preis',
      material: 'Material',
      yarnWeight: 'Garnst\u00e4rke',
      gauge: 'Maschenprobe',
      care: 'Pflege',
      certifications: 'Zertifikate'
    },
    en: {
      addToCompare: 'Add to comparison',
      added: 'Added',
      removed: 'Removed',
      yarn: 'yarn',
      yarns: 'yarns',
      maxItems: 'Maximum {n} yarns',
      show: 'View',
      compareList: 'Comparison list',
      removeAll: 'Remove all',
      loading: 'Loading data\u2026',
      minTwo: 'Add at least 2 yarns to compare.',
      loadError: 'Could not load data.',
      remove: 'Remove',
      brand: 'Brand',
      price: 'Price',
      material: 'Material',
      yarnWeight: 'Yarn weight',
      gauge: 'Gauge',
      care: 'Care',
      certifications: 'Certifications'
    },
    fr: {
      addToCompare: 'Ajouter \u00e0 la comparaison',
      added: 'Ajout\u00e9',
      removed: 'Retir\u00e9',
      yarn: 'fil',
      yarns: 'fils',
      maxItems: 'Maximum {n} fils',
      show: 'Voir',
      compareList: 'Liste de comparaison',
      removeAll: 'Tout supprimer',
      loading: 'Chargement des donn\u00e9es\u2026',
      minTwo: 'Ajoutez au moins 2 fils pour comparer.',
      loadError: 'Impossible de charger les donn\u00e9es.',
      remove: 'Retirer',
      brand: 'Marque',
      price: 'Prix',
      material: 'Mati\u00e8re',
      yarnWeight: 'Poids du fil',
      gauge: '\u00c9chantillon',
      care: 'Entretien',
      certifications: 'Certifications'
    },
    it: {
      addToCompare: 'Aggiungi al confronto',
      added: 'Aggiunto',
      removed: 'Rimosso',
      yarn: 'filato',
      yarns: 'filati',
      maxItems: 'Massimo {n} filati',
      show: 'Mostra',
      compareList: 'Lista di confronto',
      removeAll: 'Rimuovi tutto',
      loading: 'Caricamento dati\u2026',
      minTwo: 'Aggiungi almeno 2 filati per confrontare.',
      loadError: 'Impossibile caricare i dati.',
      remove: 'Rimuovi',
      brand: 'Marca',
      price: 'Prezzo',
      material: 'Materiale',
      yarnWeight: 'Peso del filato',
      gauge: 'Campione',
      care: 'Cura',
      certifications: 'Certificazioni'
    },
    es: {
      addToCompare: 'A\u00f1adir a la comparaci\u00f3n',
      added: 'A\u00f1adido',
      removed: 'Eliminado',
      yarn: 'hilo',
      yarns: 'hilos',
      maxItems: 'M\u00e1ximo {n} hilos',
      show: 'Ver',
      compareList: 'Lista de comparaci\u00f3n',
      removeAll: 'Eliminar todo',
      loading: 'Cargando datos\u2026',
      minTwo: 'A\u00f1ade al menos 2 hilos para comparar.',
      loadError: 'No se pudieron cargar los datos.',
      remove: 'Eliminar',
      brand: 'Marca',
      price: 'Precio',
      material: 'Material',
      yarnWeight: 'Peso del hilo',
      gauge: 'Muestra',
      care: 'Cuidado',
      certifications: 'Certificaciones'
    }
  };

  var locale = (document.documentElement.lang || 'de').split('-')[0].toLowerCase();

  function t(key, replacements) {
    var str = (TRANSLATIONS[locale] || TRANSLATIONS.de)[key] || TRANSLATIONS.de[key] || key;
    if (replacements) {
      for (var k in replacements) {
        if (replacements.hasOwnProperty(k)) {
          str = str.replace('{' + k + '}', replacements[k]);
        }
      }
    }
    return str;
  }

  /* -----------------------------------------------------------------------
     State helpers (localStorage)
     ----------------------------------------------------------------------- */

  function getList() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (_) {
      return [];
    }
  }

  function saveList(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('compare:updated', { detail: { list: list } }));
  }

  function addItem(item) {
    var list = getList();
    if (list.length >= MAX_ITEMS) {
      showToast(t('maxItems', { n: MAX_ITEMS }));
      return false;
    }
    if (list.some(function (i) { return i.handle === item.handle && String(i.variantId) === String(item.variantId); })) {
      return false;
    }
    list.push(item);
    saveList(list);
    return true;
  }

  function removeItem(handle, variantId) {
    var list = getList().filter(function (i) {
      return !(i.handle === handle && String(i.variantId) === String(variantId));
    });
    saveList(list);
    return list;
  }

  function clearAll() {
    saveList([]);
  }

  function isInList(handle, variantId) {
    return getList().some(function (i) {
      return i.handle === handle && String(i.variantId) === String(variantId);
    });
  }

  /* -----------------------------------------------------------------------
     Toast notification
     ----------------------------------------------------------------------- */

  var toastTimer = null;

  function ensureToastEl() {
    var el = document.getElementById('CompareToast');
    if (el) return el;
    el = document.createElement('div');
    el.id = 'CompareToast';
    el.className = 'compare-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    document.body.appendChild(el);
    return el;
  }

  function showToast(message, linkText) {
    var el = ensureToastEl();
    var html = '<span>' + message + '</span>';
    if (linkText) {
      html += ' <button type="button" class="compare-toast__link" data-compare-show>' + linkText + '</button>';
    }
    el.innerHTML = html;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
    }, 3000);
  }

  /* -----------------------------------------------------------------------
     Product page button
     ----------------------------------------------------------------------- */

  var ICON_PLUS = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  var ICON_CHECK = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
  var ICON_X_SM = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
  var ICON_CLOSE = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';

  function getCurrentVariantData() {
    var productInfo = document.querySelector('product-info');
    if (!productInfo) return null;

    var handle = productInfo.getAttribute('data-product-url');
    if (handle) {
      handle = handle.replace(/^\/products\//, '').replace(/\?.*/, '');
    }

    var variantJSON = productInfo.querySelector('[data-selected-variant]');
    var variant = null;
    if (variantJSON) {
      try {
        variant = JSON.parse(variantJSON.textContent);
      } catch (_) {}
    }
    if (!variant) return null;

    var productTitle = '';
    var titleEl = productInfo.querySelector('.product__title .title, .product__title h1, h1');
    if (titleEl) productTitle = titleEl.textContent.trim();

    var vendor = '';
    var vendorEl = productInfo.querySelector('.product__text a[href*="/collections/"], .product__vendor');
    if (vendorEl) vendor = vendorEl.textContent.trim();

    var image = '';
    if (variant.featured_image && variant.featured_image.src) {
      image = variant.featured_image.src;
    } else {
      var mainImg = document.querySelector('.product__media img[src]');
      if (mainImg) image = mainImg.src;
    }

    return {
      handle: handle,
      variantId: variant.id,
      variantTitle: variant.title || variant.option1 || '',
      productTitle: productTitle,
      vendor: vendor,
      image: image,
      price: variant.price
    };
  }

  function initProductButton() {
    var buttons = document.querySelectorAll('[data-compare-add]');
    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      function updateButtonState() {
        var data = getCurrentVariantData();
        if (data && isInList(data.handle, data.variantId)) {
          btn.classList.add('is-added');
          btn.innerHTML = ICON_CHECK + ' ' + t('added');
        } else {
          btn.classList.remove('is-added');
          btn.innerHTML = ICON_PLUS + ' ' + t('addToCompare');
        }
      }

      btn.addEventListener('click', function () {
        var data = getCurrentVariantData();
        if (!data) return;

        if (isInList(data.handle, data.variantId)) {
          removeItem(data.handle, data.variantId);
          updateButtonState();
          var count = getList().length;
          var countText = count > 0 ? ' (' + count + ' ' + (count === 1 ? t('yarn') : t('yarns')) + ')' : '';
          showToast(t('removed') + countText);
        } else {
          var added = addItem(data);
          if (added) {
            updateButtonState();
            var count = getList().length;
            showToast(t('added') + '! (' + count + ' ' + (count === 1 ? t('yarn') : t('yarns')) + ')', t('show'));
          }
        }
      });

      // Initial state
      updateButtonState();

      // Listen for variant changes via theme pubsub (variant:change CustomEvent does NOT bubble)
      if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
        theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function () {
          updateButtonState();
        });
      }

      // Listen for external compare list changes
      document.addEventListener('compare:updated', updateButtonState);
    });
  }

  /* -----------------------------------------------------------------------
     Header icon + badge (click opens modal directly)
     ----------------------------------------------------------------------- */

  function updateAllBadges() {
    var list = getList();
    document.querySelectorAll('[data-compare-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }

  function initHeaderIcon() {
    // Update badge on list changes
    document.addEventListener('compare:updated', updateAllBadges);
    updateAllBadges();
  }

  /* -----------------------------------------------------------------------
     Global click handlers (all via document delegation for reliability)
     ----------------------------------------------------------------------- */

  function initGlobalHandlers() {
    document.addEventListener('click', function (e) {
      // Header icon → open modal
      if (e.target.closest('[data-compare-toggle]')) {
        e.preventDefault();
        openCompareModal();
        return;
      }

      // Toast "show" link → open modal
      if (e.target.closest('[data-compare-show]')) {
        var toast = document.getElementById('CompareToast');
        if (toast) toast.classList.remove('is-visible');
        openCompareModal();
        return;
      }

      // Mobile menu "Vergleichsliste" button → open modal
      if (e.target.closest('[data-compare-mobile-open]')) {
        var drawer = document.getElementById('MenuDrawer');
        if (drawer) {
          var closeBtn = drawer.querySelector('[aria-controls="MenuDrawer"][aria-expanded]');
          if (closeBtn) closeBtn.click();
        }
        setTimeout(function () {
          openCompareModal();
        }, 300);
      }
    });

    // Update mobile button label for i18n
    var mobileLabel = document.querySelector('[data-compare-mobile-label]');
    if (mobileLabel) {
      mobileLabel.textContent = t('compareList');
    }

    // Sync badges on update
    document.addEventListener('compare:updated', updateAllBadges);
    updateAllBadges();
  }

  /* -----------------------------------------------------------------------
     Comparison Modal
     ----------------------------------------------------------------------- */

  var modalEl = null;

  function ensureModal() {
    if (modalEl) return modalEl;
    modalEl = document.createElement('div');
    modalEl.className = 'compare-modal';
    modalEl.id = 'CompareModal';
    modalEl.hidden = true;
    modalEl.innerHTML =
      '<div class="compare-modal__backdrop" data-compare-modal-close></div>' +
      '<div class="compare-modal__container">' +
        '<div class="compare-modal__header">' +
          '<h2 class="compare-modal__title">' + t('compareList') + '</h2>' +
          '<button type="button" class="compare-modal__close" data-compare-modal-close>' +
            ICON_CLOSE +
          '</button>' +
        '</div>' +
        '<div class="compare-modal__body" data-compare-modal-body>' +
          '<div class="compare-modal__loading">' + t('loading') + '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modalEl);

    modalEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-compare-modal-close]')) {
        closeCompareModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modalEl && !modalEl.hidden) {
        closeCompareModal();
      }
    });

    return modalEl;
  }

  function openCompareModal() {
    var modal = ensureModal();
    var body = modal.querySelector('[data-compare-modal-body]');
    body.innerHTML = '<div class="compare-modal__loading">' + t('loading') + '</div>';
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    loadCompareData(body);
  }

  function closeCompareModal() {
    if (modalEl) {
      modalEl.hidden = true;
      document.body.style.overflow = '';
    }
  }

  function loadCompareData(body) {
    var list = getList();
    if (list.length < 2) {
      body.innerHTML = '<div class="compare-modal__loading">' + t('minTwo') + '</div>';
      return;
    }

    var promises = list.map(function (item) {
      return fetch('/products/' + item.handle + '?sections=product-compare-data')
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var html = json['product-compare-data'] || '';
          var div = document.createElement('div');
          div.innerHTML = html;
          var script = div.querySelector('[data-compare-json]');
          if (script) {
            var data = JSON.parse(script.textContent);
            data._compareItem = item;
            return data;
          }
          return null;
        })
        .catch(function () { return null; });
    });

    Promise.all(promises).then(function (results) {
      results = results.filter(Boolean);
      if (results.length < 2) {
        body.innerHTML = '<div class="compare-modal__loading">' + t('loadError') + '</div>';
        return;
      }
      renderCompareTable(body, results);
    });
  }

  function renderCompareTable(body, products) {
    var allRows = [
      { label: '', key: '_header' },
      { label: t('brand'), key: 'vendor' },
      { label: t('price'), key: '_price' },
      { label: t('material'), key: 'material' },
      { label: t('yarnWeight'), key: 'yarn_weight' },
      { label: t('gauge'), key: 'maschenprobe' },
      { label: t('certifications'), key: '_certifications' }
    ];

    // Filter out rows where ALL products have empty data
    var rows = allRows.filter(function (row) {
      // Always keep header and price
      if (row.key === '_header' || row.key === '_price') return true;
      // For certifications, check if any product has certs
      if (row.key === '_certifications') {
        return products.some(function (p) {
          return p.certifications && p.certifications.length > 0;
        });
      }
      // For regular fields, check if any product has a value
      return products.some(function (p) {
        return p[row.key] && String(p[row.key]).trim() !== '';
      });
    });

    var html = '<table class="compare-table"><tbody>';

    rows.forEach(function (row) {
      html += '<tr>';
      html += '<th>' + row.label + '</th>';

      products.forEach(function (p) {
        var item = p._compareItem;
        var variant = null;
        if (p.variants) {
          variant = p.variants.find(function (v) { return String(v.id) === String(item.variantId); });
        }

        if (row.key === '_header') {
          var imgUrl = '';
          if (variant && variant.image) {
            imgUrl = sizedImage(variant.image, '300x300');
          } else if (item.image) {
            imgUrl = sizedImage(item.image, '300x300');
          } else if (p.image) {
            imgUrl = sizedImage(p.image, '300x300');
          }
          html += '<td class="compare-table__product-header">' +
            '<div class="compare-table__product-image">' +
              (imgUrl ? '<img src="' + imgUrl + '" alt="" width="80" height="80" loading="lazy">' : '') +
            '</div>' +
            '<p class="compare-table__product-name"><a href="' + (p.url || '/products/' + item.handle) + '">' + escapeHtml(p.title || item.productTitle) + '</a></p>' +
            '<p class="compare-table__product-variant">' + escapeHtml(variant ? variant.title : item.variantTitle) + '</p>' +
            '<button type="button" class="compare-table__product-remove" data-modal-remove-handle="' + item.handle + '" data-modal-remove-variant="' + item.variantId + '">' +
              ICON_X_SM + ' ' + t('remove') +
            '</button>' +
          '</td>';
        } else if (row.key === '_price') {
          var price = variant ? variant.price : item.price;
          html += '<td class="compare-table__value--highlight">' + formatMoney(price) + '</td>';
        } else if (row.key === '_certifications') {
          var certs = p.certifications;
          if (certs && certs.length) {
            html += '<td><div class="compare-table__certifications">';
            certs.forEach(function (c) {
              html += '<span class="compare-table__cert-badge">' + escapeHtml(c) + '</span>';
            });
            html += '</div></td>';
          } else {
            html += '<td class="compare-table__value--empty">\u2014</td>';
          }
        } else {
          var val = p[row.key];
          html += '<td>' + (val ? escapeHtml(val) : '<span class="compare-table__value--empty">\u2014</span>') + '</td>';
        }
      });

      html += '</tr>';
    });

    html += '</tbody></table>';
    body.innerHTML = html;

    // Remove-from-modal handlers
    body.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-modal-remove-handle]');
      if (!btn) return;
      removeItem(btn.dataset.modalRemoveHandle, btn.dataset.modalRemoveVariant);
      var list = getList();
      if (list.length < 2) {
        closeCompareModal();
      } else {
        openCompareModal();
      }
    });
  }

  /* -----------------------------------------------------------------------
     Utilities
     ----------------------------------------------------------------------- */

  function sizedImage(src, size) {
    if (!src) return '';
    if (src.indexOf('cdn.shopify.com') !== -1) {
      return src.replace(/(_\d+x\d+)?(\.(jpg|jpeg|png|gif|webp))/, '_' + size + '$2');
    }
    return src;
  }

  function formatMoney(cents) {
    if (cents == null) return '\u2014';
    var format = theme.settings.currencyCodeEnabled
      ? theme.settings.moneyWithCurrencyFormat
      : theme.settings.moneyFormat;
    return theme.Currency.formatMoney(parseInt(cents, 10), format);
  }

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  /* -----------------------------------------------------------------------
     Init
     ----------------------------------------------------------------------- */

  function init() {
    initProductButton();
    initHeaderIcon();
    initGlobalHandlers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
